import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { API } from "../../../config/config";
const { TextArea } = Input;


const ApiTokenForm = (props) => {
    const { t, data, form, layout, tailLayout, onValuesChange, onSubmit } = props;
    const [loading, setLoading] = useState(false);

    const generateNewToken = () => {
        setLoading(true);
        const apiUrl = '/genapitoken';
        Swal.fire({
            icon: "info",
            title: "Warning! Generate API Token",
            text: 'This will generate a new API Token. When you generate a new API Token your old token will be invalid. This will mean that until the new token is added, none of the API calls will be validated.',
            timer: 0,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Generate New API Token'
        }).then((res) => {
            if (res.isConfirmed) { // Show Confirmation Modal
                Swal.fire({
                    icon: "info",
                    title: "Are you sure you want to do this, it will invalidate your old API Token.",
                    timer: 0,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes'
                }).then((res) => {
                    if (res.isConfirmed) { // Generate New Token Request
                        setLoading(true);
                        axios
                            .post(API + apiUrl, { uid: data.uid }, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
                            .then((result) => {
                                result = { ...result.data };
                                data.api_token = result.api_token;
                                form.setFieldsValue({
                                    api_token: result.api_token
                                });
                                Swal.fire({
                                    icon: "success",
                                    title: "New API Token Successfully Generated.",
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            })
                            .catch((error) => {
                                console.log(error);
                                Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: t("login.dialogs.catch"),
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            }).finally(() => {
                                setLoading(false);
                            });
                    }
                })
            }
            setLoading(false);
        });
    }

    return (
        <Form {...layout} form={form} onValuesChange={onValuesChange} onFinish={onSubmit} style={{ padding: "15px 0" }}>

            <Form.Item name="api_token" label={t('contents.profile.form.api_token')} rules={[{ required: true, message: t('contents.profile.form.required_messages.changeapi_token_required') }]}>
                <TextArea disabled
                    autoSize={{ minRows: 3, maxRows: 5 }}
                />
            </Form.Item>

            <Form.Item {...tailLayout}>

                <Button htmlType="button" style={{ marginRight: "10px" }} onClick={generateNewToken} loading={loading}>
                    {t("contents.profile.form.generate_new_api_token")}
                </Button>

            </Form.Item>
        </Form>
    );
};

export default ApiTokenForm;
